// Themes
import { extendTheme } from "@chakra-ui/react";
import { checkboxTheme } from './checkbox'

export const colorAlt = "#2FB5B0";
export const colorMain = "#062a30";
const theme = extendTheme({
  fontSizes: {
    xs: "8px",
    sm: "10px",
    md: "12px",
    lg: "14px",
    xl: "16px",
    "2xl": "18px",
    "3xl": "20px",
    "4xl": "22px",
    "5xl": "24px",
    "6xl": "26px",
  },
  components: {
    Drawer: {
      parts: ["dialog", "header", "body"],
      variants: {
        primary: {},
        secondary: {
          dialog: {
            maxW: "450px",
            w: '450px',
          },
        },
      },
    },
    Checkbox: checkboxTheme
  },
  calendarIcon: {
    textColor: "white",
    primaryColor: "#062a30",
    backgroundColor: "#fafafa",
  },
});

export default theme;

export const CollectButtonStyles = {
  position: "relative",
  borderColor: "teal.200",
  bg: colorMain,
  color: "white",
  align: "center",
  fontSize: ["12px", "12px", "14px"],
  p: "14px",
  mb: 8,
  borderRadius: "12px",
  shadow: "base",
  fontWeight: "bold",
  colorScheme: "blue",
  w: "100%",
  _hover: {
    bg: "white",
    color: "#2fb5b0",
  },
  _active: {
    bg: "white",
    color: "#2fb5b0",
  },
};
